export default __webpack_public_path__ + "static/media/metricstream.73a4d3cd.svg";